"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.datesAsText = datesAsText;
exports.formatMonthYear = formatMonthYear;
exports.scheduleDescriptionOverflowCheck = scheduleDescriptionOverflowCheck;
exports.toMonthDateTime = toMonthDateTime;
exports.toggleDescription = toggleDescription;
exports.updateDescriptionOverflow = updateDescriptionOverflow;
let descriptionResizeBound = false;
const DESCRIPTION_MAX_LINES = 2;
function getLineHeightPx(computed) {
  const parsedLineHeight = Number.parseFloat(computed.lineHeight);
  if (Number.isFinite(parsedLineHeight)) {
    return parsedLineHeight;
  }
  const parsedFontSize = Number.parseFloat(computed.fontSize);
  if (Number.isFinite(parsedFontSize)) {
    return parsedFontSize * 1.5;
  }
  return 24;
}
function getExpandedTextHeight(textEl) {
  const previousDisplay = textEl.style.display;
  const previousOverflow = textEl.style.overflow;
  const previousPaddingRight = textEl.style.paddingRight;
  const previousLineClamp = textEl.style.getPropertyValue('-webkit-line-clamp');
  const previousBoxOrient = textEl.style.getPropertyValue('-webkit-box-orient');
  textEl.style.display = 'block';
  textEl.style.overflow = 'visible';
  textEl.style.paddingRight = '0';
  textEl.style.setProperty('-webkit-line-clamp', 'unset');
  textEl.style.setProperty('-webkit-box-orient', 'initial');
  const naturalHeight = textEl.getBoundingClientRect().height;
  textEl.style.display = previousDisplay;
  textEl.style.overflow = previousOverflow;
  textEl.style.paddingRight = previousPaddingRight;
  if (previousLineClamp) {
    textEl.style.setProperty('-webkit-line-clamp', previousLineClamp);
  } else {
    textEl.style.removeProperty('-webkit-line-clamp');
  }
  if (previousBoxOrient) {
    textEl.style.setProperty('-webkit-box-orient', previousBoxOrient);
  } else {
    textEl.style.removeProperty('-webkit-box-orient');
  }
  return naturalHeight;
}
function isTextOverflowingClamp(textEl, maxLines) {
  const computed = window.getComputedStyle(textEl);
  const lineHeight = getLineHeightPx(computed);
  const maxCollapsedHeight = lineHeight * maxLines;
  const naturalHeight = getExpandedTextHeight(textEl);
  return naturalHeight > maxCollapsedHeight + 1;
}
function toDateValue(date) {
  if (!date) return '';
  if (typeof date === 'string') return date;
  return date.value || '';
}

/* Function below generated by AI Model: GPT-5.3-Codex */
/* Prompt: the description needs to only show 2 lines and then more button
   please generate code for this. */
function updateDescriptionOverflow(root = document) {
  const selectorGroups = [{
    wrap: '.resume-card__description-wrap',
    text: '.resume-card__description-text',
    toggle: '.resume-card__description-toggle',
    expanded: 'resume-card__description-text--expanded',
    overflowing: 'resume-card__description-text--overflowing'
  }, {
    wrap: '.education-card__description-wrap',
    text: '.education-card__description-text',
    toggle: '.education-card__description-toggle',
    expanded: 'education-card__description-text--expanded',
    overflowing: 'education-card__description-text--overflowing'
  }, {
    wrap: '.bio-card__description-wrap',
    text: '.bio-card__description-text',
    toggle: '.bio-card__description-toggle',
    expanded: 'bio-card__description-text--expanded',
    overflowing: 'bio-card__description-text--overflowing'
  }];
  selectorGroups.forEach(({
    wrap,
    text,
    toggle,
    expanded,
    overflowing
  }) => {
    const wraps = root.querySelectorAll(wrap);
    wraps.forEach(container => {
      if (!(container instanceof HTMLElement)) return;
      const textEl = container.querySelector(text);
      const button = container.querySelector(toggle);
      if (!textEl || !button) return;
      textEl.classList.remove(overflowing);
      if (textEl.clientHeight === 0 || textEl.clientWidth === 0) {
        button.hidden = true;
        return;
      }
      const isExpanded = textEl.classList.contains(expanded);
      if (isExpanded) {
        button.hidden = false;
        return;
      }
      const isOverflowing = isTextOverflowingClamp(textEl, DESCRIPTION_MAX_LINES);
      textEl.classList.toggle(overflowing, isOverflowing);
      button.hidden = !isOverflowing;
      if (!isOverflowing) {
        button.setAttribute('aria-expanded', 'false');
        button.textContent = '...more';
        return;
      }
    });
  });
}
function scheduleDescriptionOverflowCheck() {
  if (typeof window === 'undefined') return;
  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => updateDescriptionOverflow(window.document));
  });
  if (!descriptionResizeBound) {
    window.addEventListener('resize', () => scheduleDescriptionOverflowCheck());
    descriptionResizeBound = true;
  }
}
function toggleDescription(event) {
  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation?.();
  const button = event.currentTarget;
  if (!button) return;
  const descriptionId = button.getAttribute('aria-controls');
  if (!descriptionId) return;
  const textEl = document.getElementById(descriptionId);
  if (!textEl) return;
  const expandedClass = textEl.matches('.resume-card__description-text') ? 'resume-card__description-text--expanded' : textEl.matches('.education-card__description-text') ? 'education-card__description-text--expanded' : textEl.matches('.bio-card__description-text') ? 'bio-card__description-text--expanded' : 'isExpanded';
  const isExpanded = textEl.classList.toggle(expandedClass);
  button.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
  button.textContent = isExpanded ? '...less' : '...more';
  if (!isExpanded) {
    scheduleDescriptionOverflowCheck();
  }
}

/* Function below generated by AI Model: GPT-5.3-Codex */
/* Prompt: write me a function to convert a date to Month, Year */
function formatMonthYear(date) {
  const value = toDateValue(date);
  if (!value) return '';
  const year = value.slice(0, 4);
  const month = value.slice(5, 7);
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const monthIndex = Number(month) - 1;
  if (!year || monthIndex < 0 || monthIndex > 11) return value;
  return `${monthNames[monthIndex]}, ${year}`;
}
function datesAsText(startDate, endDate) {
  const startValue = toDateValue(startDate);
  if (!startValue) return '';
  const start = formatMonthYear(startDate);
  const end = toDateValue(endDate) ? formatMonthYear(endDate) : 'Present';
  return `${start} to ${end}`;
}
function toMonthDateTime(date) {
  const value = toDateValue(date);
  if (!value) return undefined;
  return value.slice(0, 7);
}